import React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";
import MDSnackbar from "components/MDSnackbar";
import { useState } from "react";
import { CircularProgress, FormControl, InputLabel } from "@mui/material";
import appData from "layouts/Products/data/appData";
import { useAddProduct } from "api/useProducts.ts";
import { useAddMosque } from "api/useMosques.ts";
import MDBox from "components/MDBox";
import { useMediaQuery, useTheme } from "@mui/material";
import { Box } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

function Tables() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const addProduct = useAddProduct();
  const addMosque = useAddMosque();
  const [isProductModalOpen, setIsProductModalOpen] = useState(false);
  const [isMosqueModalOpen, setIsMosqueModalOpen] = useState(false);
  const [newProduct, setNewProduct] = useState({
    productName: {
      en: "",
      ar: "",
    },
    price: 0,
    stockQuantity: 0,
    category: "",
    productImg: null,
    description: {
      en: "",
      ar: "",
    },
  });
  const [newMosque, setNewMosque] = useState({
    name: "",
    address: "",
    location: {
      type: "Point",
      coordinates: [0, 0],
    },
  });

  const {
    columns,
    rows,
    editedProduct,
    handleInputChange,
    handleSaveChanges,
    isModalOpen,
    isDeleteModalOpen,
    closeDeleteModal,
    handleCloseModal,
    notification,
    setNotification,
    handleCloseNotification,
    handleDeleteProduct,
    categories,
    handleUploadImage,
    handleFileChange,
    isFileModalOpen,
    closeFileModal,
    imagePreview,
    setImagePreview,
    isUploading,
  } = appData();

  const handleAddProductClick = () => {
    setIsProductModalOpen(true); // Open modal for adding new product
  };

  const handleCloseAddProductModal = () => {
    setIsProductModalOpen(false); // Close modal
    setNewProduct({
      productName: {
        en: "",
        ar: "",
      },
      price: 0,
      stockQuantity: 0,
      category: "",
      productImg: null,
      description: {
        en: "",
        ar: "",
      },
    });
  };
  const handleInputChangeNewProduct = (e) => {
    const { name, value } = e.target;

    // Check if the input is for a nested property (e.g., productName.en)
    if (name.includes(".")) {
      const [parentKey, childKey] = name.split(".");
      setNewProduct((prevState) => ({
        ...prevState,
        [parentKey]: {
          ...prevState[parentKey],
          [childKey]: value,
        },
      }));
    } else {
      // For non-nested fields
      setNewProduct((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleSaveProduct = async () => {
    // name , price, category , description, quantity
    const productData = {
      name: {
        en: newProduct.productName.en,
        ar: newProduct.productName.ar,
      },
      price: newProduct.price,
      category: newProduct.category,
      quantity: newProduct.stockQuantity,
      description: {
        en: newProduct.description.en,
        ar: newProduct.description.ar,
      },
    };

    addProduct.mutate(productData, {
      onSuccess: () => {
        setNotification({
          open: true,
          message: "Product added successfully",
          severity: "success",
        });
        handleCloseAddProductModal(); // Close modal on success
      },
      onError: (error) => {
        console.error("Error adding product:", error);
        setNotification({
          open: true,
          message: "Failed to add product. Please try again.",
          severity: "error",
        });
      },
    });
  };

  const handleAddMosqueClick = () => {
    setIsMosqueModalOpen(true); // Open modal for adding new mosque
  };
  const handleCloseAddMosqueModal = () => {
    setIsMosqueModalOpen(false); // Close modal
    setNewMosque({
      name: "",
      address: "",
      location: {
        type: "",
        coordinates: [],
      },
    });
  };
  const handleInputChangeNewMosque = (e) => {
    const { name, value } = e.target;

    setNewMosque((prevState) => {
      if (name === "x" || name === "y") {
        const newCoordinates = [...prevState.location.coordinates];
        if (name === "x") {
          newCoordinates[1] = parseFloat(value) || ""; // Latitude at index 1
        } else {
          newCoordinates[0] = parseFloat(value) || ""; // Longitude at index 0
        }

        return {
          ...prevState,
          location: {
            ...prevState.location,
            coordinates: newCoordinates,
          },
        };
      } else if (name.includes(".")) {
        // Handle nested properties like location.type
        const [parentKey, childKey] = name.split(".");
        return {
          ...prevState,
          [parentKey]: {
            ...prevState[parentKey],
            [childKey]: value,
          },
        };
      } else {
        // Handle non-nested fields like name, address
        return {
          ...prevState,
          [name]: value,
        };
      }
    });
  };

  const handleSaveMosque = async () => {
    const mosqueData = {
      name: newMosque.name,
      address: newMosque.address,
      location: {
        type: newMosque.location.type,
        coordinates: newMosque.location.coordinates,
      },
    };

    addMosque.mutate(mosqueData, {
      onSuccess: () => {
        setNotification({
          open: true,
          message: "Mosque added successfully",
          severity: "success",
        });
        handleCloseAddMosqueModal(); // Close modal on success
      },
      onError: (error) => {
        console.error("Error adding mosque:", error);
        setNotification({
          open: true,
          message: "Failed to add mosque. Please try again.",
          severity: "error",
        });
      },
    });
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="dark"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                flexDirection={isMobile ? "column" : "row"}
                justifyContent="space-between"
                alignItems={isMobile ? "flex-start" : "center"}
              >
                <MDTypography variant="h6" color="white">
                  Products Table
                </MDTypography>
                <MDBox
                  display="flex"
                  flexDirection={isMobile ? "column" : "row"}
                  gap={isMobile ? 2 : "10px"}
                  width={isMobile ? "100%" : "auto"}
                >
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleAddProductClick}
                    fullWidth={isMobile} // Full width for mobile
                    sx={{
                      borderRadius: 2,
                      fontSize: 14,
                      padding: "8px 16px",
                      color: "black",
                    }}
                  >
                    Add Product
                  </Button>
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleAddMosqueClick}
                    fullWidth={isMobile}
                    sx={{
                      borderRadius: 2,
                      fontSize: 14,
                      padding: "8px 16px",
                      color: "black",
                    }}
                  >
                    Add Mosque
                  </Button>
                </MDBox>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  entriesPerPage={false}
                  showTotalEntries
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
      <Dialog open={isProductModalOpen} onClose={handleCloseAddProductModal}>
        <DialogTitle>Add New Product</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              {/* Product Name (English) */}
              <TextField
                name="productName.en"
                label="Product Name (English)"
                value={newProduct.productName.en}
                onChange={handleInputChangeNewProduct}
                fullWidth
                margin="dense"
              />
            </Grid>
            <Grid item xs={6}>
              {/* Product Name (Arabic) */}
              <TextField
                name="productName.ar"
                label="Product Name (Arabic)"
                value={newProduct.productName.ar}
                onChange={handleInputChangeNewProduct}
                fullWidth
                margin="dense"
                dir="rtl" // Right-to-left direction for Arabic
              />
            </Grid>
          </Grid>

          {/* Category Selection */}
          <FormControl fullWidth margin="dense">
            <InputLabel id="category-label">Category</InputLabel>
            <Select
              style={{ padding: "10px 0" }}
              labelId="category-label"
              name="category"
              value={newProduct.category?._id}
              onChange={handleInputChangeNewProduct}
              fullWidth
            >
              {categories?.map((category) => (
                <MenuItem key={category?._id} value={category?._id}>
                  {category.name.en} | {category.name.ar}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Price Input */}
          <TextField
            name="price"
            label="Price"
            value={newProduct.price}
            onChange={handleInputChangeNewProduct}
            type="number"
            fullWidth
            margin="dense"
          />

          {/* Stock Quantity */}
          <TextField
            name="stockQuantity"
            label="Stock Quantity"
            value={newProduct.stockQuantity}
            onChange={handleInputChangeNewProduct}
            type="number"
            fullWidth
            margin="dense"
          />
          <Grid container spacing={2}>
            <Grid item xs={6}>
              {/* Description (English) */}
              <TextField
                name="description.en"
                label="Description (English)"
                value={newProduct.description.en}
                onChange={handleInputChangeNewProduct}
                fullWidth
                margin="dense"
                multiline
                rows={4}
              />{" "}
            </Grid>
            <Grid item xs={6}>
              {/* Description (Arabic) */}
              <TextField
                name="description.ar"
                label="Description (Arabic)"
                value={newProduct.description.ar}
                onChange={handleInputChangeNewProduct}
                fullWidth
                margin="dense"
                multiline
                rows={4}
                dir="rtl" // Right-to-left direction for Arabic
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAddProductModal} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSaveProduct} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Mosque Modal */}
      <Dialog open={isMosqueModalOpen} onClose={handleCloseAddMosqueModal}>
        <DialogTitle>Add New Mosque</DialogTitle>
        <DialogContent>
          <TextField
            name="name"
            label="Mosque Name"
            value={newMosque.name || ""}
            onChange={handleInputChangeNewMosque}
            fullWidth
            margin="dense"
          />
          <TextField
            name="address"
            label="Mosque Address"
            value={newMosque.address || ""}
            onChange={handleInputChangeNewMosque}
            fullWidth
            margin="dense"
          />
          <TextField
            name="location.type"
            label="Location Type"
            value={newMosque.location?.type || ""}
            onChange={handleInputChangeNewMosque}
            fullWidth
            margin="dense"
          />
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                name="x"
                label="Latitude (X)"
                type="number"
                value={newMosque.location?.coordinates[1] || ""} // Ensure index 1 for latitude
                onChange={handleInputChangeNewMosque}
                fullWidth
                margin="dense"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                name="y"
                label="Longitude (Y)"
                type="number"
                value={newMosque.location?.coordinates[0] || ""} // Ensure index 0 for longitude
                onChange={handleInputChangeNewMosque}
                fullWidth
                margin="dense"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAddMosqueModal} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSaveMosque} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
      {/* Edit Product Modal */}
      <Dialog
        open={isModalOpen}
        onClose={handleCloseModal}
        TransitionComponent={Fade}
        TransitionProps={{ timeout: 500 }}
      >
        <DialogTitle>Edit Product Details</DialogTitle>
        {editedProduct && (
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  name="productName.en"
                  label="Product Name (English)"
                  value={editedProduct.productName.en}
                  onChange={handleInputChange}
                  fullWidth
                  margin="dense"
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  name="productName.ar"
                  label="Product Name (Arabic)"
                  value={editedProduct.productName.ar}
                  onChange={handleInputChange}
                  fullWidth
                  margin="dense"
                  dir="rtl"
                />
              </Grid>
            </Grid>

            <FormControl fullWidth margin="dense">
              <InputLabel id="category-label">Category</InputLabel>
              <Select
                style={{ padding: "10px 0" }}
                labelId="category-label"
                name="category"
                value={editedProduct.category?._id}
                onChange={handleInputChange}
                fullWidth
              >
                {categories &&
                  categories.map((category) => (
                    <MenuItem key={category?._id} value={category._id}>
                      {category.name.en} | {category.name.ar}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            <TextField
              name="price"
              label="Price"
              type="number"
              value={editedProduct.price}
              onChange={handleInputChange}
              fullWidth
              margin="dense"
            />

            <TextField
              name="stockQuantity"
              label="Stock Quantity"
              type="number"
              value={editedProduct.stockQuantity}
              onChange={handleInputChange}
              fullWidth
              margin="dense"
            />

            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  name="description.en"
                  label="Description (English)"
                  value={editedProduct.description.en}
                  onChange={handleInputChange}
                  fullWidth
                  margin="dense"
                  multiline
                  rows={4}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  name="description.ar"
                  label="Description (Arabic)"
                  value={editedProduct.description.ar}
                  onChange={handleInputChange}
                  fullWidth
                  margin="dense"
                  multiline
                  rows={4}
                  dir="rtl"
                />
              </Grid>
            </Grid>
          </DialogContent>
        )}
        <DialogActions>
          <Button onClick={handleCloseModal} color="secondary">
            Cancel
          </Button>
          <Button onClick={() => handleSaveChanges(editedProduct)} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
      {/* Confirm Deletion */}
      <Dialog
        open={isDeleteModalOpen}
        onClose={closeDeleteModal}
        TransitionComponent={Fade}
        TransitionProps={{ timeout: 500 }}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <MDTypography variant="body1" color="textSecondary">
            Are you sure you want to delete this product?
          </MDTypography>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDeleteModal} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleDeleteProduct} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      {/* File Modal */}
      <Dialog
        open={isFileModalOpen}
        onClose={closeFileModal}
        TransitionComponent={Fade}
        TransitionProps={{ timeout: 500 }}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Edit Product Image</DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
            {/* Image Preview */}
            {imagePreview && (
              <Box
                component="img"
                src={imagePreview}
                alt="Product Preview"
                sx={{
                  width: "100%",
                  height: "auto",
                  maxHeight: 300,
                  borderRadius: 2,
                  objectFit: "contain",
                  border: "1px solid #ccc",
                }}
              />
            )}
            <Button component="label" tabIndex={-1} startIcon={<CloudUploadIcon />} fullWidth>
              Upload Product Image
              <input hidden accept="image/*" type="file" name="image" onChange={handleFileChange} />
            </Button>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeFileModal} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handleUploadImage}
            color="primary"
            disabled={isUploading || !imagePreview}
            startIcon={isUploading ? <CircularProgress size={20} /> : null}
          >
            {isUploading ? "Uploading..." : "Save"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Notification Snackbar */}
      <MDSnackbar
        color={notification.severity}
        icon={notification.severity === "success" ? "check" : "error"}
        title={notification.severity === "success" ? "Success" : "Error"}
        content={notification.message}
        open={notification.open}
        onClose={handleCloseNotification}
        close={handleCloseNotification}
        bgWhite
      />
    </DashboardLayout>
  );
}

export default Tables;
